import { useCallback, useState } from "react";
import useSWR from "swr";
import { fetcher } from "../../../services/fetcher";
import { AssignCover_API } from "../../../api/endpoints";

export const useLazyAssignPlans = () => {
  const [enabled, setEnabled] = useState(false);

  const { data, error, isLoading } = useSWR(enabled ? AssignCover_API : null, fetcher, {
    revalidateOnFocus: false,
  });

  const loadPlans = useCallback(() => setEnabled(true), []);
  const resetPlansLoad = useCallback(() => setEnabled(false), []);

  const plans = Array.isArray(data?.customize_covers) ? data.customize_covers : [];

  return {
    plans,
    isPlansLoading: enabled && isLoading,
    plansError: error,
    loadPlans,
    resetPlansLoad,
  };
};
